import { ImMap } from '../helpers/ImmutableTypes';
import { Portal } from '../Portal/types';
import {
  ROUTE_COURSE_PAGE,
  ROUTE_INSTITUTION_PAGE,
  ROUTE_INSTITUTION_QUALIFICATION_PAGE,
  ROUTE_INSTITUTION_HOMEPAGE,
} from '../routeActions';
import { ValidExternalLinkPages } from './types';

const isValidPortalRoute = (
  currentRouteType: ValidExternalLinkPages
): boolean => {
  switch (currentRouteType) {
    case ROUTE_COURSE_PAGE:
    case ROUTE_INSTITUTION_PAGE:
    case ROUTE_INSTITUTION_QUALIFICATION_PAGE:
    case ROUTE_INSTITUTION_HOMEPAGE:
      return true;
    default:
      return false;
  }
};

export const getPortalExternalLogInLink = (
  currentRouteType: ValidExternalLinkPages,
  portal: ImMap<Portal> | null
): string | null => {
  if (portal === null || !isValidPortalRoute(currentRouteType)) return null;
  return portal.get('externalLogInLink', null);
};

export const getPortalExternalSignUpLink = (
  currentRouteType: ValidExternalLinkPages,
  portal: ImMap<Portal> | null
): string | null => {
  if (portal === null || !isValidPortalRoute(currentRouteType)) return null;
  return portal.get('externalSignUpLink', null);
};
